import {NgModule} from '@angular/core';
import {ConfiguratorPageEventService} from './configurator-page-event.service';
import {CpqConfiguratorPageEventService} from './cpq-configurator-page-event.service';
import {CheckoutDataEntryPageEventService} from './checkout-data-entry-page-event.service';
import {CheckoutReviewOrderPageEventService} from './checkout-review-order-page-event.service';
import {OrderConfirmationPageEventService} from './order-confirmation-page-event.service';
import {ErrorPageEventService} from './error-page-event.service';
import {ErrorPageMissingEventService} from './error-page-missing-event.service';
import {CategoryPageEventService} from './category-page-event.service';
import {SearchPageEventService} from './search-page-event.service';

@NgModule({
  providers: [
    ConfiguratorPageEventService,
    CpqConfiguratorPageEventService,
    CheckoutDataEntryPageEventService,
    CheckoutReviewOrderPageEventService,
    OrderConfirmationPageEventService,
    ErrorPageEventService,
    ErrorPageMissingEventService,
    CategoryPageEventService,
    SearchPageEventService,
  ],
})
export class ConfiguratorPageEventModule {
  constructor(
    _checkoutPageEventBuilder: ConfiguratorPageEventService,
    _cpqCheckoutPageEventBuilds: CpqConfiguratorPageEventService,
    _checkoutDataEntryPageEventBuilder: CheckoutDataEntryPageEventService,
    _checkoutReviewOrderPageEventBuilder: CheckoutReviewOrderPageEventService,
    _orderConfirmationPageEventBuilder: OrderConfirmationPageEventService,
    _errorPageEventBuilder: ErrorPageEventService,
    _errorPageMissingEventBuilder: ErrorPageMissingEventService,
    _categoryPageEventBuilder: CategoryPageEventService,
    _searchPageEventBuilder: SearchPageEventService
  ) {
    // Intentional empty constructor
  }
}
